<app-header [isuser]="isUserlogined" />
<router-outlet />
<a [ngClass]="{active:isButtonVisible}" id="toTop" class="slide-in" (click)="scrollToTop()"><i class="fa fa-chevron-up"
        aria-hidden="true"></i></a>
<app-footer />